module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sj-f8f9b21529bdc34df1b56eb5523e0977.svg";